import { cryptoLogin, login } from '@ogsnetwork/opp-redux-lib';
import { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector, usePrevious } from '../index';
export function useLogin(props) {
    const authentication = useAppSelector((state) => state.authentication);
    const dispatch = useAppDispatch();
    const previousStatus = usePrevious(authentication.status);
    const [password, setPassword] = useState('');
    const [username, setUsername] = useState('');
    const [disableLogin, setDisableLogin] = useState(true);
    const dispatchLogin = useCallback(() => {
        dispatch(login({ password, username }));
    }, [password, username]);
    useEffect(() => {
        if (username.length === 0 || password.length === 0) {
            setDisableLogin(true);
        }
        else {
            setDisableLogin(false);
        }
    }, [username, password]);
    useEffect(() => {
        var _a, _b;
        if (authentication.status === 'loggedIn' && previousStatus === 'submitting') {
            setPassword('');
            setUsername('');
            (_a = props === null || props === void 0 ? void 0 : props.onLogin) === null || _a === void 0 ? void 0 : _a.call(props);
        }
        if (authentication.status === 'error' && previousStatus === 'submitting') {
            (_b = props === null || props === void 0 ? void 0 : props.onError) === null || _b === void 0 ? void 0 : _b.call(props);
        }
    }, [authentication.status]);
    return {
        password,
        username,
        dispatchLogin,
        disableLogin,
        setPassword,
        setUsername,
        error: authentication.error,
        status: authentication.status
    };
}
export function useCryptoLogin(props) {
    const authentication = useAppSelector((state) => state.authentication);
    const dispatch = useAppDispatch();
    const previousStatus = usePrevious(authentication.status);
    function dispatchCryptoLogin(address, signature) {
        dispatch(cryptoLogin({ address, signature }));
    }
    useEffect(() => {
        var _a, _b;
        if (authentication.status === 'loggedIn' && previousStatus === 'submitting') {
            (_a = props === null || props === void 0 ? void 0 : props.onLogin) === null || _a === void 0 ? void 0 : _a.call(props);
        }
        if (authentication.status === 'error' && previousStatus === 'submitting') {
            (_b = props === null || props === void 0 ? void 0 : props.onError) === null || _b === void 0 ? void 0 : _b.call(props);
        }
    }, [authentication.status]);
    return {
        dispatchCryptoLogin,
        error: authentication.error,
        status: authentication.status
    };
}
